import { SOLANA_WALLET_LOCAL_STORAGE_KEY } from 'app/solana-config'

export function clearSolanaWalletSession() {
  localStorage.removeItem(SOLANA_WALLET_LOCAL_STORAGE_KEY)
}
